import { deviceDetector } from '../util/is_mobile'
import { isNativeApp } from '../util/detection'
import { inTestEnvironment } from '../util/environment'

up.compiler('body', (body: HTMLBodyElement) => {
  let deviceClass: string

  if (deviceDetector.isMobile() || (inTestEnvironment() && isNativeApp())) {
    deviceClass = '-mobile'
  } else if (deviceDetector.isTablet()) {
    deviceClass = '-tablet'
  } else {
    deviceClass = '-desktop'
  }

  body.classList.add(deviceClass)
})
